/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Flex, Tooltip } from "@nordcloud/gnui";
import { MultiSelectButton } from "../Styled/MultiSelectButton";
import { FiltersProp, PremiumSupportCSP } from "./types";

type Props = {
  value: PremiumSupportCSP[];
  filters: FiltersProp;
  setFilters: (filter: FiltersProp) => void;
};

export function PremiumSupportCSPSelect({ value, filters, setFilters }: Props) {
  const togglePremiumSupport = (option: PremiumSupportCSP) => {
    let psFilter: PremiumSupportCSP[] = [];
    if (filters.premiumSupportCSP?.includes(option)) {
      psFilter = filters.premiumSupportCSP?.filter((item) => item !== option);
    } else {
      psFilter = [...(filters.premiumSupportCSP ?? []), option];
    }
    setFilters({ ...filters, premiumSupportCSP: psFilter });
  };

  return (
    <Flex justifyContent="flex-start">
      <Tooltip caption="AWS">
        <MultiSelectButton
          icon="aws"
          value={value?.includes(PremiumSupportCSP.AWS)}
          severity="medium"
          onClick={() => togglePremiumSupport(PremiumSupportCSP.AWS)}
          aria-label="aws-icon"
        />
      </Tooltip>
      <Tooltip caption="GCP">
        <MultiSelectButton
          icon="gcp"
          value={value?.includes(PremiumSupportCSP.GCP)}
          severity="medium"
          onClick={() => togglePremiumSupport(PremiumSupportCSP.GCP)}
          aria-label="gcp-icon"
        />
      </Tooltip>
      <Tooltip caption="AZURE">
        <MultiSelectButton
          icon="azure"
          value={value?.includes(PremiumSupportCSP.AZURE)}
          severity="medium"
          onClick={() => togglePremiumSupport(PremiumSupportCSP.AZURE)}
          aria-label="azure-icon"
        />
      </Tooltip>
      <Tooltip caption="None">
        <MultiSelectButton
          icon="cloudError"
          value={value?.includes(PremiumSupportCSP.NONE)}
          severity="medium"
          onClick={() => togglePremiumSupport(PremiumSupportCSP.NONE)}
          aria-label="cloudError-icon"
        />
      </Tooltip>
    </Flex>
  );
}
